import WidgetLink from './Link';

export default WidgetLink;
